import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import TextInput from "@/components/input/TextInput";
import DropdownSelect from "@/components/input/DropdownSelect";
import Datepicker from "@/components/input/DatePickerWithInput";
import PropertyToolBar from "@/components/property/PropertyToolBar";
import TextArea from "@/components/input/TextArea";
import PercentInput from "@/components/input/PercentInput";
import ReadField from "@/components/input/ReadField";
import DollarInput from "@/components/input/DollarInput";
import MoneyInput from "@/components/input/MoneyInput";
import BoolSelect from "@/components/input/BoolSelect";
import FieldFactory from "@/components/input/FieldFactory";
import APIDropdown from "@/components/dropdowns/APIDropdown";
import grid from "components/dataTable/grid";
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            Vue.component("TextInput", TextInput);
            Vue.component("DropdownSelect", DropdownSelect);
            Vue.component("Datepicker", Datepicker);
            Vue.component("TextArea", TextArea);
            Vue.component("PercentInput", PercentInput);
            Vue.component("ReadField", ReadField);
            Vue.component("DollarInput", DollarInput);
            Vue.component("MoneyInput", MoneyInput);
            Vue.component("BoolSelect", BoolSelect);
            Vue.component("PropertyToolBar", PropertyToolBar);
            Vue.component("FieldFactory", FieldFactory);
            Vue.component("APIDropdown", APIDropdown);
            Vue.component("grid", grid);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();